export default "__VITE_ASSET__BUAa4OOT__"